<template>
  <!--:maskClosable="false"-->
  <a-drawer
    :width="width"
    :visible="visible"
    :zIndex="1001"
    @ok="handleOk"
    :closable="false"
    :headerStyle="{paddingTop:'0px',background:'#fff'}"
    :bodyStyle="{background:'#fff',padding: 0 }"
    :drawerStyle="{background:'#fff'}"
    @close="handleCancel"
    cancelText="关闭">
    <div class="model-top">
      <div>上传附件</div>
      <div class="right-btns">
        <span class="delete-order"  @click="handleCancel">
          <img class="icon" src="@/assets/driver/delete.png"/>
        </span>
      </div>
    </div>

    <driver-file-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit" normal></driver-file-form>
    <div class="drawer-footer">
      <a-button  @click="handleOk"   type="primary" style="margin-bottom: 0;width: 482px">确定</a-button>
    </div>
  </a-drawer>
</template>

<script>

  import { httpAction, getAction,getFileAccessHttpUrl } from '@/api/manage'
  import DriverFileForm from "./DriverFileForm";

  export default {
    name: 'DriverFileModal',
    components: {
      DriverFileForm
    },
    data () {
      return {
        title:"上传附件",
        width:540,
        visible: false,
        disableSubmit: false,
      }
    },created(){

    },
    methods: {
      add (record) {
        this.disableSubmit = false;
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add(record);
        })
      },edit(record){
        this.disableSubmit = false;
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },handleCancel(){
        this.close()
      },submitCallback(){
        this.$emit('ok');
        this.visible = false;
      }
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
.model-top{
  height: 76px;
  line-height: 76px;
  color: #0A1629;
  font-size: 24px;
  background:rgba(255, 255, 255, 1);
  padding-left: 40px;
  border-bottom: 1px solid rgba(228, 230, 232, 1);
  display: flex;
  justify-content: space-between;
}
.right-btns{
  display: flex;
  align-items:center;
}

.right-btns span{
  padding: 0 10px;
  text-align: center;
  border-radius: 12px;
  cursor: pointer;
  margin-right: 20px;
  background: rgba(244, 249, 253, 1);
  width: 44px;
  height: 44px;
  line-height: 44px;
}
.right-btns span img{
  width: 24px;
}
.right-btns span:hover{
  opacity: .8;
}
.top-bg0{
  background: rgba(255, 255, 255, 1);
}
.drawer-footer .ant-btn {
  margin-left: 30px;
  margin-bottom: 30px;
  float: right;

}
.drawer-footer{
  justify-content: center;
  display: flex;
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: center;
  left: 0;
  border-radius: 0 0 2px 2px;
  background: #fff;
}
/deep/ .ant-drawer-body{
  padding: 0 !important;
}
/deep/ .ant-modal-footer{
  text-align: center !important;
}

</style>